import * as React from 'react';
import { useAutocomplete } from '@react-aria/autocomplete';
import { useFilter } from '@react-aria/i18n';
import { useAutocompleteState } from '@react-stately/autocomplete';

var useSelectAutocomplete = function useSelectAutocomplete() {
  var inputRef = React.useRef(null);
  var internalCollectionRef = React.useRef(null);
  var state = useAutocompleteState({});
  var _useFilter = useFilter({
      sensitivity: 'base'
    }),
    contains = _useFilter.contains;
  var _useAutocomplete = useAutocomplete({
      inputRef: inputRef,
      collectionRef: internalCollectionRef,
      filter: contains
    }, state),
    collectionRef = _useAutocomplete.collectionRef,
    collectionProps = _useAutocomplete.collectionProps,
    textFieldProps = _useAutocomplete.textFieldProps,
    filter = _useAutocomplete.filter;
  return {
    inputRef: inputRef,
    collectionRef: collectionRef,
    textFieldProps: textFieldProps,
    collectionProps: collectionProps,
    filter: filter
  };
};

export { useSelectAutocomplete };
//# sourceMappingURL=useSelectAutocomplete.js.map
